import { createElement, forwardRef } from 'react';
import { ComponentSize } from '../common/constants';
import classNames from 'classnames';
export let IconType = /*#__PURE__*/function (IconType) {
  IconType["OUTLINED"] = "OUTLINED";
  IconType["FILLED"] = "FILLED";
  return IconType;
}({});
export const Icon = /*#__PURE__*/forwardRef(({
  size,
  className,
  component,
  style,
  children,
  type = IconType.FILLED,
  ...rest
}, ref) => /*#__PURE__*/createElement(component, {
  className: classNames(`frontino-icon frontino-icon--${size}`, className, type === IconType.OUTLINED && 'frontino-icon__outlined'),
  style,
  ref,
  ...rest
}, children));
Icon.frontinoName = 'FrontinoIcon';
Icon.defaultProps = {
  component: 'span',
  size: ComponentSize.MEDIUM
};